/**
 *  业务埋点参数收集
 */
import { billTypeMap } from '@/omega/const/index';

const defaultUuid = Date.now();
class LogParams {
  constructor() {
    this.state = {
      event_type: billTypeMap.fast,
      uuid: defaultUuid,
    };
  }
  setBillEventType(event_type) {
    this.state.event_type = event_type;
  }
  getBillEventType() {
    return this.state.event_type;
  }
  setBillUuid() {
    this.state.uuid = Date.now();
  }
  getBillUuid() {
    return this.state.uuid;
  }
}

export default new LogParams();
